import {DigitalProductRepository} from "./digital-product.repository";
import {DigitalProductRepositoryV2} from "./digital-product.repository.v2";

export type {DigitalProductRepository} from "./digital-product.repository";
export {DigitalProductRepositoryV2} from "./digital-product.repository.v2";

/**
 * Factory function to create the digital product repository.
 * Always returns the v2 implementation (v1 has been removed).
 */
export const createDigitalProductRepository = (): DigitalProductRepository => {
  return new DigitalProductRepositoryV2();
};
